export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';

export function showNotification() {
  return {
    type: SHOW_NOTIFICATION,
    show: true
  };
}

export function hideNotification() {
  return {
    type: HIDE_NOTIFICATION,
    notificationType: null,
    message: null,
    show: false
  };
}

export function setNotification(payload) {
  return {
    type: SET_NOTIFICATION,
    ...payload
  };
}



// WEBPACK FOOTER //
// ./src/Actions/Notification.js